module.exports = __webpack_public_path__ + "assets/img/product_coffein@2x.f5823de2.jpg";